<div style="position: relative;" class="header  main-backgroundcolor color margin-b">
    <div class="display" style="justify-content: space-between;align-items: center;">
        <div class="cursor" (click)="redirect()"><i class="fas fa-arrow-left"></i></div>
        <div class="text"> {{title}}
        </div>
    </div>

</div>